// Generated file : do not modify
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { PaymentMeansTypes } from '@/generated/classes/PaymentMeans';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Paniers
export class CartItem {
  // Type d'objet'
  public objType: ObjTypes;
  // ID de l'objet
  public objId: number;
  // Payé immédiatement
  public auto: boolean;
  // Selectionné pour paiement
  public selected: boolean;
  // Libellé
  public label: string;
  // Référence
  public reference: string;
  // Projet
  public projet: string;
  // Date
  public date: Date;
  // Selectionné pour paiement
  public selectedHt: number;
  // Selectionné pour paiement
  public selectedTva: number;
  // Selectionné pour paiement
  public selectedTtc: number;

  constructor() {
    this.objType = ObjTypes.NONE;
    this.objId = 0;
    this.auto = false;
    this.selected = false;
    this.label = '';
    this.reference = '';
    this.projet = '';
    this.date = new Date(1901,1,1,0,0,0,0);
    this.selectedHt = 0;
    this.selectedTva = 0;
    this.selectedTtc = 0;
  }
}

export default class Cart  {
  // Identifiant unique
  public id: number;
  // Liste des items du pannier
  public cartItems: CartItem[];
  // Somme à régler
  public selectedTtc: number;
  // Somme à régler
  public selectedLetterTtc: string;
  // Item en attente de validation support
  public hasWaitingItems: boolean;
  // Owner
  public owner: Owner;
  // Vérifie l'opération si total négatif
  public verify: boolean;
  // Utilisé pour le règlement d'une paie
  public fromPaie: boolean;
  // Type de paiement
  public paymentMeansType: PaymentMeansTypes;
  // Moyen de paiement
  public paymentMeansId: number;
  // Ferme le dialog
  public closeDialog: boolean;
  // Minimum d'un remboursement
  public minRepay: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Type
  public ownerType: number;
  // Identifiant
  public ownerId: number;
  // Nom
  public ownerLabel: string;

  constructor() {
    this.id = 0;
    this.cartItems = [];
    this.selectedTtc = 0;
    this.selectedLetterTtc = '';
    this.hasWaitingItems = false;
    this.owner = new Owner();
    this.verify = false;
    this.fromPaie = false;
    this.paymentMeansType = PaymentMeansTypes.NONE;
    this.paymentMeansId = 0;
    this.closeDialog = false;
    this.minRepay = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
  }

  public static fromJson (obj: Cart): Cart {
    const newCart: Cart = new Cart();
    newCart.id = obj.id;
    newCart.cartItems = JSON.parse(JSON.stringify(obj.cartItems));
    newCart.selectedTtc = obj.selectedTtc;
    newCart.selectedLetterTtc = obj.selectedLetterTtc;
    newCart.hasWaitingItems = obj.hasWaitingItems;
    newCart.owner = JSON.parse(JSON.stringify(obj.owner));
    newCart.verify = obj.verify;
    newCart.fromPaie = obj.fromPaie;
    newCart.paymentMeansType = obj.paymentMeansType;
    newCart.paymentMeansId = obj.paymentMeansId;
    newCart.closeDialog = obj.closeDialog;
    newCart.minRepay = obj.minRepay;
    newCart.canUpdate = obj.canUpdate;
    newCart.canDelete = obj.canDelete;
    newCart.display = obj.display;
    newCart.notifDefType = obj.notifDefType;
    newCart.ownerType = obj.ownerType;
    newCart.ownerId = obj.ownerId;
    newCart.ownerLabel = obj.ownerLabel;
    return newCart;
  }

  public toJsonCart (): string {
    const json = {
      cartItems: this.cartItems,
      selectedTtc: this.selectedTtc,
      selectedLetterTtc: this.selectedLetterTtc,
      hasWaitingItems: this.hasWaitingItems,
      owner: this.owner,
      verify: this.verify,
      fromPaie: this.fromPaie,
      paymentMeansType: this.paymentMeansType,
      paymentMeansId: this.paymentMeansId,
      closeDialog: this.closeDialog,
      minRepay: this.minRepay,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromCart (obj: Cart): void {
    this.id = obj.id;
    this.cartItems = obj.cartItems;
    this.selectedTtc = obj.selectedTtc;
    this.selectedLetterTtc = obj.selectedLetterTtc;
    this.hasWaitingItems = obj.hasWaitingItems;
    this.owner = obj.owner;
    this.verify = obj.verify;
    this.fromPaie = obj.fromPaie;
    this.paymentMeansType = obj.paymentMeansType;
    this.paymentMeansId = obj.paymentMeansId;
    this.closeDialog = obj.closeDialog;
    this.minRepay = obj.minRepay;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
  }

  public compareCart (value: Cart): boolean {
    return (this.toJsonCart() == value.toJsonCart());
  }

  public cloneCart (): Cart {
    return Cart.fromJson(this);
  }

  public update (): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/carts/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromCart(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public create (): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromCart(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static command (cart: Cart): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/command', cart, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Cart.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getCart (owner: Owner): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/getCart', owner, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Cart.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static repay (cart: Cart): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/repay', cart, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Cart.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Carts/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Cart.fromJson(listData.reccords[0] as Cart);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(carts: Cart[]) {
  }
}
